var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{class:{ 'TileData__highlighted': _vm.highlight }},[_c('td',{staticClass:"d-block mr-4"},[_c('strong',{staticStyle:{"text-transform":"capitalize"}},[_vm._t("first-column")],2)]),_c('td',{staticClass:"text-center pr-4"},[_vm._t("second-column")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }